/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import ConfirmDialog from '@components/ConfirmDialog/ConfirmDialog';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { AIDeficiencyReviewStatus } from '../types';
var Steps;
(function (Steps) {
    Steps[Steps["WaitingReview"] = AIDeficiencyReviewStatus.WaitingReview] = "WaitingReview";
    Steps[Steps["InitialIncorrect"] = AIDeficiencyReviewStatus.Incorrect] = "InitialIncorrect";
    Steps["IncorrectToRemotion"] = "IncorrectToRemotion";
    Steps["IncorrectToEdit"] = "IncorrectToEdit";
    Steps["NewDeficiency"] = "NewDeficiency";
    Steps[Steps["Correct"] = AIDeficiencyReviewStatus.Correct] = "Correct";
    Steps[Steps["Removed"] = AIDeficiencyReviewStatus.Removed] = "Removed";
})(Steps || (Steps = {}));
const StatusSteps = {
    [Steps.WaitingReview]: ({ onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent" },
            React.createElement("span", { className: "footerTitle" }, translate('is_this_correct', { namespace: 'features.commons' })),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { onClick: () => onChangeStep(Steps.InitialIncorrect), variant: "secondary" },
                    React.createElement("i", { className: "fa-light fa-xmark" }),
                    "No"),
                React.createElement(Button, { onClick: () => onChangeStep(Steps.Correct), variant: "secondary" },
                    React.createElement("i", { className: "fa-light fa-check" }),
                    "Yes"))));
    },
    [Steps.InitialIncorrect]: ({ onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent dialogMode" },
            React.createElement("i", { role: "presentation", className: "fa-light fa-xmark", onClick: () => onChangeStep(Steps.WaitingReview) }),
            React.createElement("span", { className: "footerTitle" }, "Tell us more"),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { onClick: () => onChangeStep(Steps.IncorrectToRemotion), variant: "secondary" }, "This is not a deficiency"),
                React.createElement(Button, { onClick: () => onChangeStep(Steps.IncorrectToEdit), variant: "secondary" }, "The details are incorrect"))));
    },
    [Steps.IncorrectToRemotion]: ({ onRequestRemove, onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent dialogMode" },
            React.createElement("i", { role: "presentation", className: "fa-light fa-xmark", onClick: () => onChangeStep(Steps.WaitingReview) }),
            React.createElement("span", { className: "footerTitle" }, "This is not a deficiency. Do you want to remove it?"),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { onClick: () => onRequestRemove === null || onRequestRemove === void 0 ? void 0 : onRequestRemove(), variant: "secondary" }, "Remove"))));
    },
    [Steps.IncorrectToEdit]: ({ onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent dialogMode" },
            React.createElement("i", { role: "presentation", className: "fa-light fa-xmark", onClick: () => onChangeStep(Steps.InitialIncorrect) }),
            React.createElement("span", { className: "footerTitle" }, "The deficiency details are incorrect. Correct them above and update to mark it correct."),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { type: "submit", onClick: () => onChangeStep === null || onChangeStep === void 0 ? void 0 : onChangeStep(Steps.Correct), variant: "secondary" }, "Update and Mark Correct"))));
    },
    [Steps.NewDeficiency]: ({ onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent dialogMode" },
            React.createElement("span", { className: "footerTitle" }, "Fill out the deficiency details. Mark as correct to add it to the list."),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { type: "submit", onClick: () => onChangeStep === null || onChangeStep === void 0 ? void 0 : onChangeStep(Steps.Correct), variant: "secondary" }, "Add and Mark Correct"))));
    },
    [AIDeficiencyReviewStatus.Correct]: ({ onChangeStep }) => {
        return (React.createElement("section", { className: "footerContent" },
            React.createElement("span", { className: "footerTitle" }, translate('is_this_correct', { namespace: 'features.commons' })),
            React.createElement("div", { className: "options" },
                React.createElement(Button, { onClick: () => onChangeStep(Steps.InitialIncorrect), variant: "secondary" },
                    React.createElement("i", { className: "fa-light fa-xmark" }),
                    "No"),
                React.createElement(Button, { disabled: true, variant: "secondary" },
                    React.createElement("i", { className: "fa-light fa-check" }),
                    "Yes"))));
    },
    [AIDeficiencyReviewStatus.Removed]: () => {
        return React.createElement("div", null);
    }
};
export default function BrushawaySteps({ deficiency, onChangeStatus, onStartEditing, onStopEditing }) {
    const [currentStep, setCurrentStep] = useState(deficiency ? deficiency.reviewStatus : Steps.NewDeficiency);
    const StepComp = StatusSteps[currentStep];
    const [isConfirmRemotionModalOpen, setIsConfirmRemotionModalOpen] = React.useState(false);
    useEffect(() => {
        if (deficiency === null || deficiency === void 0 ? void 0 : deficiency.deficiency_uid) {
            setCurrentStep(deficiency.reviewStatus);
        }
        else {
            setCurrentStep(Steps.NewDeficiency);
        }
    }, [deficiency === null || deficiency === void 0 ? void 0 : deficiency.reviewStatus]);
    const onChangeStep = (nextStep) => {
        // In this case we wait for the deficiency to be updated by the backend
        if (nextStep !== Steps.Correct) {
            setCurrentStep(nextStep);
        }
        if (nextStep === Steps.InitialIncorrect) {
            onChangeStatus(AIDeficiencyReviewStatus.Incorrect);
        }
        else if (nextStep === Steps.Correct) {
            onChangeStatus(AIDeficiencyReviewStatus.Correct);
        }
        else if (nextStep === Steps.IncorrectToEdit) {
            onStartEditing();
        }
        else if (nextStep === Steps.WaitingReview) {
            onChangeStatus(AIDeficiencyReviewStatus.WaitingReview);
        }
        if (nextStep !== Steps.IncorrectToEdit && nextStep !== Steps.Correct) {
            onStopEditing();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StepComp, { onChangeStep: onChangeStep, onRequestRemove: () => setIsConfirmRemotionModalOpen(true) }),
        isConfirmRemotionModalOpen && (React.createElement(ConfirmDialog, { title: "Remove Deficiency", description: "Do you want to remove this deficiency?", onConfirm: () => onChangeStatus(AIDeficiencyReviewStatus.Removed), onCancel: () => setIsConfirmRemotionModalOpen(false) }))));
}
